// src/components/LoadingOverlay.js
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAppContext } from '../contexts/AppContext';

const LoadingOverlay = () => {
  const { appState, updateAppState } = useAppContext();

  if (!appState.loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingOverlay;
